module.exports = __webpack_public_path__ + "ecb4572a5e478b107dfcb60c16a7eefa.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Light/OpenSans-Light.ttf?v=1.1.0
// module id = 975
// module chunks = 0